import * as React from 'react';

export default class PasswordResetSuccess extends React.PureComponent {

    render() {
        return (
            <div className="row">
                <div className="col-md-4 offset-md-4">
                    <div style={styles.body}>
                        <h2>Password Changed!</h2>
                        <p>Your password has been sucessfully changed. Please return to the app to log in.</p>
                    </div>
                </div>
            </div>
        );
    }
}

const styles = {
    body: {
        marginTop: '5rem',
        padding: '2rem',
        border: '1px solid #eee',
        borderRadius: '10px',
    },
};



// WEBPACK FOOTER //
// ./src/components/PasswordResetSuccess.tsx